import AddPortraitEdit from "./components/AddPortraitEdit";

function getElem(node, isUserInput) {
    const prefix = node.type === "param" ? "{" : "[";
    const subfix = node.type === "param" ? "}" : "]";
    const text = isUserInput ? `${node.key}${subfix}` : `${prefix}${node.key}${subfix}`;
    return {
        isText: true,
        innerText: text
    };
}

// link，question，higlight配置
export default {
    type: "portrait",
    labelKey: "zhiji.answer.textWidget.addPortrait",
    cls: "",
    tipsComponent: null,
    triggerChar(store, { char, position }, cb) {
        if (char !== "{" && char !== "[") {
            // 关闭添加画像参数浮框
            store.state.zhiji.modalState.modals.some(item => {
                if (item.type === AddPortraitEdit) {
                    this.$store.dispatch("zhiji/hideModal", AddPortraitEdit);
                }
            });
            return false;
        }
        const left = `${position.left}px`;
        const top = `${position.top + 15}px`;
        store.dispatch("zhiji/showModal", {
            type: AddPortraitEdit,
            data: {
                type: char === "{" ? "param" : "tag",
                position: {
                    left,
                    top
                },
                callback(res) {
                    const node = {
                        cmdNode: true,
                        id: `${res.type}${res.key}`,
                        type: res.type,
                        key: res.key,
                        paramId: res.value && res.value.toString(),
                        source: res.source != null ? res.source : "",
                    };
                    const elem = getElem(node, true);
                    cb({ elem, node });
                }
            }
        });
        return true;
    },
    editorHandler: (store, { event }, cb) => {
        // 获取当前位置
        const element = event.target.getBoundingClientRect();
        const left = `${element.left}px`;
        const top = `${element.top + element.height + 5}px`;
        store.dispatch("zhiji/showModal", {
            type: AddPortraitEdit,
            data: {
                position: {
                    left,
                    top
                },
                callback(res) {
                    const node = {
                        cmdNode: true,
                        id: `${res.type}${res.key}`,
                        type: res.type,
                        key: res.key,
                        paramId: res.value && res.value.toString(),
                        source: res.source != null ? res.source : "",
                    };
                    const elem = getElem(node);
                    cb({ elem, node });
                }
            }
        });
    },
    toHtml(node) {
        const prefix = node.type === "param" ? "{" : "[";
        const subfix = node.type === "param" ? "}" : "]";
        return `${prefix}${node.key}${subfix}`;
    },
    fromOut(cmd) {
        const { type, key, paramId, source } = cmd;
        return { id: `${type}${key}`, type, key, paramId, source, cmdNode: true };
    },
    toOut(node) {
        const { type, key, paramId, source } = node;
        return { type, key, paramId, source };
    },
    getTips() {
        return "";
    }
};
